import React, { FC, ReactElement } from 'react'
import { HStack, Text } from '@chakra-ui/react'

interface ICellHeaderProps {
  icon?: ReactElement
  children?: React.ReactNode
}

export const CellHeader: FC<ICellHeaderProps> = ({ icon, children }) => (
  <HStack>
    <Text>{children}</Text>
    {icon ? icon : ''}
  </HStack>
)
